module.exports = __webpack_public_path__ + "img/device.255796b5.jpg";